import React, { Component } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Link } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import './../../css/table.css';

const MySwal = withReactContent(Swal);

export default class CategoryJobOpportunityAdd extends Component {
    constructor() {
        super();
        this.state = {
            category: '',
            category_fa: '',
            loading: false
        };
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        const { category, category_fa } = this.state;

        if (!category.trim() || !category_fa.trim()) {
            MySwal.fire({
                title: 'لطفاً همه فیلدها را پر کنید',
                icon: 'warning',
            });
            return;
        }

        this.setState({ loading: true });

        axios
            .post('https://arianaapp.arianaapply.com/panel/insert-category-job-opportunity', {
                category: category.trim(),
                category_fa: category_fa.trim()
            })
            .then((res) => {
                this.setState({ loading: false });
                MySwal.fire({
                    title: 'دسته‌بندی با موفقیت ثبت شد',
                    icon: 'success',
                }).then(() => {
                    this.props.history.push('/category-job-list');
                });
            })
            .catch((err) => {
                this.setState({ loading: false });
                const message = err.response?.data?.message || 'خطا در ثبت دسته‌بندی';
                MySwal.fire({
                    title: message,
                    icon: 'error',
                });
            });
    };

    render() {
        const { category, category_fa, loading } = this.state;

        return (
            <div className='index'>
                <form onSubmit={this.handleSubmit} style={{ width: '90%', maxWidth: '700px' }}>
                    <h4 style={{ marginBottom: '1.5rem', color: '#693668', textAlign: 'center' }}>
                        افزودن دسته‌بندی جدید
                    </h4>

                    <div className='inputBox'>
                        <label>نام انگلیسی (category)</label>
                        <input
                            type='text'
                            name='category'
                            value={category}
                            onChange={this.handleChange}
                            placeholder='مثلاً: programming'
                            required
                        />
                    </div>

                    <div className='inputBox'>
                        <label>نام فارسی (category_fa)</label>
                        <input
                            type='text'
                            name='category_fa'
                            value={category_fa}
                            onChange={this.handleChange}
                            placeholder='مثلاً: برنامه‌نویسی'
                            required
                        />
                    </div>

                    <div className='inputBox' style={{ marginTop: '30px', display: 'flex', gap: '15px', flexDirection: 'row', justifyContent: 'center' }}>
                        <button
                            type='submit'
                            className='btn-success'
                            disabled={loading}
                            style={{ width: '180px', marginBottom: 0 }}
                        >
                            {loading ? <Spinner animation='border' size='sm' /> : 'ثبت دسته‌بندی'}
                        </button>

                        <Link to='/category-job-list'>
                            <button
                                type='button'
                                style={{
                                    width: '120px',
                                    height: '50px',
                                    borderRadius: '3px',
                                    border: 'none',
                                    background: '#dc3545',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    marginTop: '5px'
                                }}
                            >
                                انصراف
                            </button>
                        </Link>
                    </div>
                </form>
            </div>
        );
    }
}